export const SET_FAQS = 'SET_FAQS';
export const REMOVE_ITEMS = 'REMOVE_ITEMS';
export const REMOVE_FAQS = 'REMOVE_FAQS';